@if (method === 'manual' || method === 'both') {
    <tec-upload
        [multiple]="multiple"
        [hasButton]="true"
        [acceptedFileTypes]="acceptedFileTypes"
        [browseButtonLabel]="browseButtonLabel || ('DOCUMENTS.EXPLORE' | translate)"
        [formControl]="control"
        [ariaLabel]="ariaLabel"
        (fileSelected)="onFileSelected($event)"
    >
        @if (method === 'both') {
            <tec-button
                secondary-button
                type="secondary"
                size="xs"
                icon="icon-camera"
                iconPosition="left"
                (click)="onCameraClick()"
            >
                {{ 'DOCUMENTS.TAKE_PHOTO' | translate }}
            </tec-button>
        }
    </tec-upload>
} @else {
    <tec-button
        secondary-button
        type="secondary"
        size="xs"
        icon="icon-camera"
        iconPosition="left"
        (click)="onCameraClick()"
    >
        {{ 'DOCUMENTS.TAKE_PHOTO' | translate }}
    </tec-button>
}
